import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import ArrowBack from '@material-ui/icons/ArrowBack'

import history from '../../history'


const styles = {
  navButton: {
    fontSize: '1.06rem',
    textTransform: 'capitalize'
  },
  root: {
    flexWrap: 'wrap',
    height: 444,
    marginTop: 100,
    paddingTop: 30,
    textAlign: 'center'
  }
}

const withErrorNavigation = (config={}) => WrappedComponent => {
  class WithErrorNavigation extends Component {
    render() {
      return (
        <Grid container justify="center" style={styles.root}>
          <Grid container justify="center" alignContent="center" item xs={10}>
            <WrappedComponent/>
          </Grid>
          <Grid container justify="center" item xs={10}>
            <Grid item xs="auto">
              {config.href && (
                <Button
                  color="primary"
                  component={Link}
                  style={styles.navButton}
                  to={config.href}
                >
                  <ArrowBack style={{marginRight: 10}}/>
                  <span>Go Home</span>
                </Button>
              )}
              {config.withBackButton && (
                <Button
                  color="primary"
                  onClick={() => history.go(-1)}
                  style={styles.navButton}
                >
                  <ArrowBack style={{marginRight: 10}}/>
                  Go Back
                </Button>
              )}
            </Grid>
          </Grid>
        </Grid>
      )
    }
  }
  return WithErrorNavigation
}

export default withErrorNavigation


// WEBPACK FOOTER //
// ./src/components/error-notices/withErrorNavigationHOC.js